import { BelongsTo, Column, DataType, ForeignKey, Model, Table } from 'sequelize-typescript'

import { CuentaModel } from '../../plataforma/models/aplicacion.model'

@Table({
  freezeTableName: true,
  modelName: 'mensajes_recibido',
  timestamps: false,
})
export class MensajeRecibidoModel extends Model {
  @ForeignKey(() => CuentaModel)
  @Column({
    type: DataType.INTEGER,
    allowNull: false,
  })
  cuentaId!: number

  @Column({
    type: DataType.STRING(55),
    allowNull: false,
  })
  tipoMensaje: string

  @Column({
    type: DataType.JSON,
    allowNull: false,
  })
  mensaje!: any

  @Column({
    type: DataType.TINYINT,
    allowNull: false,
    defaultValue: false,
  })
  rechazado!: boolean

  @Column({
    type: DataType.TINYINT,
    allowNull: false,
    defaultValue: false,
  })
  eliminado!: boolean

  @BelongsTo(() => CuentaModel)
  applicacion!: CuentaModel
}
